import { render } from "./budget-revenues.vue?vue&type=template&id=139017c6"
import script from "./budget-revenues.vue?vue&type=script&lang=js"
export * from "./budget-revenues.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__